import React from 'react';
import { Button } from '../ui/button';
import { X, WarningCircle } from '@phosphor-icons/react';

export default function CommunicationConfirmDialog({
  confirmDialog,
  actionLoading,
  pecTestAddr,
  setPecTestAddr,
  onSendTestEmail,
  onSendPecTest,
  onSendPec,
  onClose,
}) {
  const { type, province, customsOffice, customsPec } = confirmDialog;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="confirm-dialog-overlay">
      <div className="bg-white rounded-sm w-full max-w-md p-6 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-slate-900">
            {type === 'test' ? 'Conferma Invio Mail Test' : type === 'pec_test' ? 'Invio PEC di Prova' : 'Conferma Invio PEC Definitiva'}
          </h3>
          <button onClick={onClose} className="p-1 hover:bg-slate-100 rounded" data-testid="confirm-close">
            <X size={20} className="text-slate-500" />
          </button>
        </div>

        {type === 'test' ? (
          <div className="space-y-3">
            <div className="bg-blue-50 border border-blue-200 rounded-sm p-4">
              <p className="text-sm text-blue-900">
                Stai per inviare una <strong>email di test</strong> per la provincia <strong>{province}</strong> all'indirizzo email di test configurato nelle impostazioni aziendali.
              </p>
            </div>
            <p className="text-sm text-slate-600">Confermi l'invio?</p>
          </div>
        ) : type === 'pec_test' ? (
          <div className="space-y-3">
            <div className="bg-amber-50 border border-amber-200 rounded-sm p-4">
              <p className="text-sm text-amber-900">
                Invia una <strong>PEC di prova</strong> per la provincia <strong>{province}</strong>. La PEC verra inviata tramite il tuo account PEC configurato.
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Indirizzo PEC destinatario</label>
              <input
                type="email"
                value={pecTestAddr}
                onChange={(e) => setPecTestAddr(e.target.value)}
                placeholder="indirizzo@pec.it"
                className="w-full px-3 py-2 text-sm border border-slate-300 rounded-sm focus:outline-none focus:ring-1 focus:ring-amber-500"
                data-testid="pec-test-address-input"
              />
              <p className="mt-1 text-xs text-slate-500">Inserisci l'indirizzo PEC a cui vuoi inviare la prova</p>
            </div>
          </div>
        ) : (
          <div className="space-y-3">
            <div className="bg-amber-50 border border-amber-200 rounded-sm p-4">
              <div className="flex items-start gap-2">
                <WarningCircle size={20} className="text-amber-600 mt-0.5 shrink-0" />
                <div>
                  <p className="text-sm text-amber-900 font-medium">Attenzione: questa azione e' definitiva!</p>
                  <p className="text-sm text-amber-800 mt-1">
                    La comunicazione PEC per la provincia <strong>{province}</strong> verra inviata a:
                  </p>
                  <p className="text-sm font-mono text-amber-900 mt-1">{customsPec}</p>
                  <p className="text-xs text-amber-700 mt-2">({customsOffice})</p>
                </div>
              </div>
            </div>
            <p className="text-sm text-slate-600">Sei sicuro di voler procedere con l'invio definitivo?</p>
          </div>
        )}

        <div className="flex justify-end gap-3 mt-6">
          <Button variant="outline" onClick={onClose} className="rounded-sm" data-testid="confirm-cancel">Annulla</Button>
          {type === 'test' ? (
            <Button onClick={() => onSendTestEmail(province)} disabled={actionLoading[province + '_test']} className="bg-blue-600 hover:bg-blue-700 text-white rounded-sm" data-testid="confirm-send-test">
              {actionLoading[province + '_test'] ? 'Invio in corso...' : 'Conferma Invio Test'}
            </Button>
          ) : type === 'pec_test' ? (
            <Button onClick={() => onSendPecTest(province)} disabled={actionLoading[province + '_pectest'] || !pecTestAddr.trim()} className="bg-amber-600 hover:bg-amber-700 text-white rounded-sm" data-testid="confirm-send-pec-test">
              {actionLoading[province + '_pectest'] ? 'Invio PEC...' : 'Conferma Invio PEC Prova'}
            </Button>
          ) : (
            <Button onClick={() => onSendPec(province)} disabled={actionLoading[province + '_pec']} className="bg-green-600 hover:bg-green-700 text-white rounded-sm" data-testid="confirm-send-pec">
              {actionLoading[province + '_pec'] ? 'Invio in corso...' : 'Conferma Invio PEC'}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
